import TimelineItem from "types/TimelineItem";
import TimelinePositions from "../types/TimelinePositions";

export default function getAbsoluteTimeFromRelativeTime(
  relativeTime: number,
  timelinePositionIndex: number,
  timelinePositions: TimelinePositions,
): number {
  const startTimes = Array.from(timelinePositions.keys());
  const timelineStart = startTimes[timelinePositionIndex];
  const timelineItem = timelinePositions.get(timelineStart) as TimelineItem;

  return timelineStart + relativeTime - timelineItem.startTime;
}
